var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "member-management" },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          model: {
            value: _vm.activeTab,
            callback: function ($$v) {
              _vm.activeTab = $$v
            },
            expression: "activeTab",
          },
        },
        [
          _c("el-tab-pane", { attrs: { label: "门店统计", name: "list" } }, [
            _c("div", { staticClass: "search-area" }, [
              _c(
                "div",
                { staticClass: "search-content" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "search-form",
                      attrs: { inline: true, model: _vm.searchForm },
                    },
                    [
                      _c(
                        "el-form-item",
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "datetimerange",
                              "range-separator": "至",
                              "start-placeholder": "开始时间",
                              "end-placeholder": "结束时间",
                              format: "yyyy-MM-dd HH:mm:ss",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              clearable: "",
                              "default-time": ["00:00:00", "23:59:59"],
                            },
                            model: {
                              value: _vm.searchForm.regTimeRange,
                              callback: function ($$v) {
                                _vm.$set(_vm.searchForm, "regTimeRange", $$v)
                              },
                              expression: "searchForm.regTimeRange",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "区域",
                                clearable: "",
                                filterable: "",
                                multiple: "",
                              },
                              model: {
                                value: _vm.searchForm.areaIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "areaIds", $$v)
                                },
                                expression: "searchForm.areaIds",
                              },
                            },
                            _vm._l(_vm.areaOptions, function (area) {
                              return _c("el-option", {
                                key: area.id,
                                attrs: { label: area.areaName, value: area.id },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                placeholder: "城市",
                                filterable: "",
                                clearable: "",
                                multiple: "",
                              },
                              model: {
                                value: _vm.searchForm.cityIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "cityIds", $$v)
                                },
                                expression: "searchForm.cityIds",
                              },
                            },
                            _vm._l(_vm.regionOptions, function (province) {
                              return _c("el-option", {
                                key: province.regionId,
                                attrs: {
                                  label: province.regionName,
                                  value: province.regionId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "shop-select",
                              attrs: {
                                placeholder: "门店",
                                clearable: "",
                                filterable: "",
                                multiple: "",
                              },
                              model: {
                                value: _vm.searchForm.storeIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "storeIds", $$v)
                                },
                                expression: "searchForm.storeIds",
                              },
                            },
                            _vm._l(_vm.storeList, function (shop) {
                              return _c("el-option", {
                                key: shop.storeId,
                                attrs: {
                                  label: shop.storeName,
                                  value: shop.storeId,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "shop-select",
                              attrs: {
                                placeholder: "场景",
                                clearable: "",
                                filterable: "",
                                multiple: "",
                              },
                              model: {
                                value: _vm.searchForm.orderSaleTypes,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.searchForm,
                                    "orderSaleTypes",
                                    $$v
                                  )
                                },
                                expression: "searchForm.orderSaleTypes",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "堂食", value: 1 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "自提", value: 2 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "外卖", value: 3 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "shop-select",
                              attrs: {
                                placeholder: "是否打包",
                                clearable: "",
                                filterable: "",
                              },
                              model: {
                                value: _vm.searchForm.packageFlag,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "packageFlag", $$v)
                                },
                                expression: "searchForm.packageFlag",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "打包", value: 1 },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "非打包", value: 0 },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "shop-select",
                              attrs: {
                                placeholder: "时段",
                                clearable: "",
                                filterable: "",
                                multiple: "",
                              },
                              model: {
                                value: _vm.searchForm.timeSlots,
                                callback: function ($$v) {
                                  _vm.$set(_vm.searchForm, "timeSlots", $$v)
                                },
                                expression: "searchForm.timeSlots",
                              },
                            },
                            _vm._l(_vm.timeSlotList, function (timeSlot) {
                              return _c("el-option", {
                                key: timeSlot.time,
                                attrs: {
                                  label:
                                    timeSlot.name + "  ·  " + timeSlot.time,
                                  value: timeSlot.time,
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "action-buttons" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", loading: _vm.searchLoading },
                      on: { click: _vm.handleSearch },
                    },
                    [_vm._v("搜索")]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.statisticsLoading,
                    expression: "statisticsLoading",
                  },
                ],
                staticClass: "statistics-container",
              },
              [
                _c("div", { staticClass: "statistics-card" }, [
                  _c("div", { staticClass: "card-title" }, [
                    _vm._v("总营业额"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-value" }, [
                    _vm._v(
                      _vm._s(_vm.formatAmount(_vm.statisticData.totalAmount))
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "statistics-card" }, [
                  _c("div", { staticClass: "card-title" }, [
                    _vm._v("总含税纯收"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-value" }, [
                    _vm._v(
                      _vm._s(_vm.formatAmount(_vm.statisticData.totalTaxAmount))
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "statistics-card" }, [
                  _c("div", { staticClass: "card-title" }, [
                    _vm._v("总订单数"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-value" }, [
                    _vm._v(_vm._s(_vm.statisticData.totalOrder || 0)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "statistics-card" }, [
                  _c("div", { staticClass: "card-title" }, [_vm._v("客单价")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-value" }, [
                    _vm._v(
                      _vm._s(_vm.formatAmount(_vm.statisticData.avgPrice))
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "statistics-card" }, [
                  _c("div", { staticClass: "card-title" }, [
                    _vm._v("总退款额"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-value" }, [
                    _vm._v(
                      _vm._s(
                        _vm.formatAmount(_vm.statisticData.totalRefundAmount)
                      )
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "statistics-card" }, [
                  _c("div", { staticClass: "card-title" }, [
                    _vm._v("总退款订单数"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "card-value" }, [
                    _vm._v(_vm._s(_vm.statisticData.totalRefundOrder || 0)),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.revenueAndVolumeLoading,
                    expression: "revenueAndVolumeLoading",
                  },
                ],
                staticClass: "chart-container",
              },
              [
                _c("div", {
                  ref: "revenueAndVolumeChart",
                  staticClass: "chart",
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.sceneStackLoading,
                    expression: "sceneStackLoading",
                  },
                ],
                staticClass: "chart-container",
              },
              [_c("div", { ref: "sceneStackChart", staticClass: "chart" })]
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }